import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class DownloadNav extends BLComponent {
	constructor (props) {
		super(props);
	}

	render() {
		const {page} = this.props;
		return (
			<div className={"edge-to-edge-container studio-download__internal-nav-container studio-download__internal-nav-container--" + (page == 1 ? 'studio' : 'partdesigner')}>
				<div className="edge-to-edge-container__internal">
					<div className="studio-download__internal-nav">
						{page == 1 ? <strong className="studio-download__internal-nav-item">Studio</strong> : <a href={blapp.url2.getStudioDownloadUrl()} className="studio-download__internal-nav-item">Studio</a>}
						{page == 2 ? <strong className="studio-download__internal-nav-item">PartDesigner</strong> : <a href={blapp.url2.getPartDesignerDownloadUrl()} className="studio-download__internal-nav-item">PartDesigner</a>}
					</div>
				</div>
			</div>
		);
	}
}